import api from '@/api/jobTemplate'

const state = {

}

const actions = {
  getJobTemplateList (context, params) {
    return api.getJobTemplateList(params)
  },
  getJobTemplateById (context, templateId) {
    return api.getJobTemplateById(templateId)
  },
  createJobTemplate (context, data) {
    return api.createJobTemplate(data)
  },
  updateJobTemplate (context, { templateId, data }) {
    return api.updateJobTemplate(templateId, data)
  },
  changeJobTemplateStatus (context, { id, newStatus }) {
    return api.changeJobTemplateStatus(id, newStatus)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
